module.exports = __webpack_public_path__ + "static/media/udeconce.6bcc7897.png";